import { useState } from "react";
import Tabs from '../../custom_components/Tabs.js';
import EmployeeDetails from 'pages/employee/EmployeeDetails.js';
import EmployeeCertificates from 'pages/employee/EmployeeCertificates.js';
import { WidgetBreadCrumbHeader } from '../../custom_components/Widgets.js'
import DoApplicationDetails from "./DoApplicationDetails.js";
import {
    useParams
} from "react-router-dom"
import PdfViewer from '../../custom_components/PdfViewer.js'
import { WidgetBackBtn } from '../../custom_components/Widgets.js'
import { useFetchPost } from '../../custom_hooks/Actions.js';

const path = process.env.REACT_APP_PATH;
const domain = process.env.REACT_APP_DOMAIN

function TabDisplay(props) {
    let activeTab = props.activeTab;
    let tabs = props.tabs;
    switch (activeTab) {
        case tabs[0]:
            return (<DoApplicationDetails />);
        case tabs[1]:
            return (<DoFilePreview />);
        default:
            return (null);
    }
}

function DoApplicationInfo({ defaultTab }) {
    const tabs = ["Details", "File Attachment"];
    const [activeTab, setActiveTab] = useState(defaultTab ? defaultTab : tabs[0])
    return (
        <div>
            <WidgetBreadCrumbHeader prevNav="Do" curNav="Do Application Information" prevLink={"#"} curLink={"#"} />
            <br />
            <Tabs tabs={tabs} state={{ activeTab: [activeTab, setActiveTab] }} onClick={() => setActiveTab(defaultTab)} />
            <TabDisplay activeTab={activeTab} tabs={tabs} />
        </div>
    )
}


function DoFilePreview(props) {
    
    let { id } = useParams();
    console.log(id);
    let fetchData = useFetchPost(
        // window.location.toString().split(path)[0] + path +
         domain + "/api/FinanceModule/DoPreview.php",{doId: id})
         function RenderViewer({ data }) {
            return (
                <div className="preview-container">
                    {data.map((item, index) => {
                        const fileExtension = item.split(".").pop().toLowerCase();  // Extract the file extension and convert to lowercase
        
                        return (
                            <div key={index} className="preview-item">
                                {fileExtension === "pdf" ? (
                                    <PdfViewer targetPath={item} />
                                ) : ["png", "jpg", "jpeg"].includes(fileExtension) ? (
                                    <img
                                        className="img-preview-item"
                                        src={item}
                                        alt={`preview-do-${index}`}
                                    />
                                ) : (
                                    <div>Preview is not available for file {item}</div>
                                )}
                            </div>
                        );
                    })}
                </div>
            );
        }

    return (
        <div className="mt-5 ">
            <div className="d-flex justify-content-center align-items-center">
                {
                    fetchData.status === "fetched" ?
                        <RenderViewer data={fetchData.data[1] ? fetchData.data[1] : null} />
                    : fetchData.status === "fetching" ?
                        <div>Loading...</div>
                    :
                        <div>Preview is not available for Cert ID {id}</div>
                }
            </div>
            
            <div className="form-button-grid">
                <WidgetBackBtn />
            </div>
        </div>
    )
}

export default DoApplicationInfo;